import React, { PureComponent } from "react"
import PropTypes from "prop-types"

import Item from "./components/Item"
import Error from "./components/Error"

import styles from "./parcelsListTableDesktop.css"

class ParcelsListTableDesktop extends PureComponent {
  renderHeader() {
    return (
      <thead>
        <tr>
          <th className={styles.number}>tracking number</th>
          <th className={styles.destination}>destination</th>
          <th>status</th>
          <th colSpan={2}>service type</th>
        </tr>
      </thead>
    )
  }

  render() {
    const { parcels, errors } = this.props

    return (
      <table className={`${styles.table} horizontal-headers hidden-xs`}>
        {this.renderHeader()}
        <tbody>
          {parcels.map(parcel => <Item key={parcel.tracking_number} parcel={parcel} />)}
          {errors.map(error => <Error key={error.tracking_number} number={error.tracking_number} />)}
        </tbody>
      </table>
    )
  }
}

ParcelsListTableDesktop.propTypes = {
  errors: PropTypes.array.isRequired,
  parcels: PropTypes.array.isRequired,
}

export default ParcelsListTableDesktop



// WEBPACK FOOTER //
// ./src/views/Parcels/components/ParcelsList/ParcelsListTableDesktop/ParcelsListTableDesktop.js